import ApiConfig from "../../../api/api.config";

export const getImageSource = (logoFileId: string) => {
  return `${ApiConfig.getEntryPoint()}files/${logoFileId}`;
};
